export default {"src":"/_next/static/media/BackButtonBlack.22807eff.svg","height":13,"width":8,"blurWidth":0,"blurHeight":0};